// Master override store: master edits to demo-directory records (caregivers, geo facilities)
// persist per-browser until those modules get real backend persistence.
export const CG_OVERRIDE_KEY = "nt_caregiver_overrides";
export const FAC_OVERRIDE_KEY = "nt_facility_overrides";

export const getOverrides = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key) || "{}");
  } catch {
    return {};
  }
};

export const saveOverride = (key, id, patch) => {
  const all = getOverrides(key);
  all[id] = { ...all[id], ...patch };
  localStorage.setItem(key, JSON.stringify(all));
  return all[id];
};

export const applyOverrides = (key, list) => {
  const all = getOverrides(key);
  return list.map((item) => (all[item.id] ? { ...item, ...all[item.id] } : item));
};
